import * as React from 'react';
import styles from './QRCodeButton.module.css';
import { QRCodeModal } from './QRCodeModal';

export const QRCodeButton: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <button
        className={styles['circular-button']}
        style={style}
        onClick={(e) => {
          e.stopPropagation();
          setModalOpen(true);
        }}
      >
        <img
          src="/static/images/map/qr_code.svg"
          alt=""
          className={styles['circular-button-icon']}
        />
      </button>
      {modalOpen && (
        <QRCodeModal
          onClose={(e) => {
            e.stopPropagation();
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
